import * as React from "react";

import { connect, useSelector } from "react-redux";

import { loadOrgStructures } from "../../orgStructure";

import { ApplicationState } from "../../../applicationState";

import { All } from "./All";
import Detail from "./Detail";
import { Edit } from "./Edit";
import { Create } from "./Create";
import { ManagerSraSummary } from "./stressRiskAssessmentCase/ManagerSraSummary";
import { CustomerUserAuditLog } from "./CustomerUserAuditLog";

import { Fragment } from "redux-little-router";

interface DispatchProps {
    loadOrgStructures(customerId: string): void;
}

const BaseUnconnected: React.FunctionComponent<DispatchProps> = (props: DispatchProps) => {

    const customerId = useSelector((state: ApplicationState) => state.router.params?.customerId);

    React.useEffect(() => {
        if (customerId) {
            props.loadOrgStructures(customerId);
        }
    });

    return (
        <>
            <Fragment forRoute="/" withConditions={l => l.params?.customerUserId === undefined}>
                <div>
                    <All />
                    <Create />
                </div>
            </Fragment>
            <Fragment forRoute="/:customerUserId/myResults/:caseId">
                <ManagerSraSummary />
            </Fragment>
            <Fragment forRoute="/:customerUserId/auditLog">
                <CustomerUserAuditLog />
            </Fragment>
            <Fragment forRoute="/:customerUserId">
                <div>
                    <Detail />
                    <Edit />
                </div>
            </Fragment>
        </>
    );
};

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
    loadOrgStructures: (customerId: string) => dispatch(loadOrgStructures({ customerId })),
});

export const Base = connect(null, mapDispatchToProps)(BaseUnconnected);
